import { EntityLayout } from '@backstage/plugin-catalog';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Grid } from '@material-ui/core';
import React, {  useState } from 'react';

import { CustomDomainEntityLayout } from '../../../pages/EntityLayout/CustomDomainEntityLayout';
import GuardRails from '../../../pages/GuardRails';
import JiraBoard from '../../../pages/JiraEpics/JiraBoard';
import GuideLines from '../../../pages/GuideLines';
import { LinearProgress } from '@mui/material';
import { ProductList } from '../../../pages/Products';
import { techdocsContent } from '../content/techdocsContent';
import { isTechDocsAvailable } from '@backstage/plugin-techdocs';
import { makeStyles } from '@material-ui/styles';
import { EntityDomainPageAboutCard } from '@internal/plugin-domain-page-about-card';

interface DomainPageProps {
  entityWarningContent: JSX.Element;
}
export type TeamEntry = {
  url: string;
  team: string;
};

export type GroupedData = {
  parent: string;
  area: string;
  teams: TeamEntry[];
};

const useStyles = makeStyles({
  container: {
    marginTop: '1rem',
  },
});

export interface teamsProps {
  team: string;
  urls: string;
}

export function DomainPage(props: DomainPageProps) {
  const classes = useStyles();
  const { entity } = useEntity();

  const path = window?.location?.pathname;
  const isDevSecOps =
    path?.split('/')[3] === 'domain' && path?.split('/')[4] === 'cop_dso';
  const isCop = entity.metadata.tags?.toString() === 'cop';
  const [isLoading, setIsLoading] = useState(true);

  //const [mappedTeam, setMappedTeam] = useState<GroupedData[]>([]);
  const updateLoading = (state: boolean) => {
    setIsLoading(state);
  };



  return (
    <CustomDomainEntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          {props.entityWarningContent}
          <Grid item md={6} xs={12}>
            <Grid className={classes.container}>
              <EntityDomainPageAboutCard from="domain" />
            </Grid>
            
          </Grid>
          <Grid item md={6} xs={12}>
            <Grid className={classes.container}>
              <ProductList
              type='individual'
                title="Products"
              />
            </Grid>
          </Grid>
        </Grid>
      </EntityLayout.Route>
      {(isDevSecOps || isCop) && (
        <>
          <EntityLayout.Route path="/guardRails" title="GuardRails">
            <>
              {isLoading && <LinearProgress />}
              {<GuardRails setIsLoading={updateLoading}  />}
            </>
          </EntityLayout.Route>
        </>
      )}
      {isDevSecOps && (
        <EntityLayout.Route path="/epics" title="Epics">
          <JiraBoard />
        </EntityLayout.Route>
      )}
      {isDevSecOps && (
        <EntityLayout.Route path="/guidelines" title="GuideLines">
          <GuideLines />
        </EntityLayout.Route>
      )}
      {isTechDocsAvailable(entity) && (
        <EntityLayout.Route path="/docs" title="Docs">
          {techdocsContent}
        </EntityLayout.Route>
      )}
    </CustomDomainEntityLayout>
  );
}
